<div class="row expansion-container"> 
    <div [ngClass]="{'expansion-header-container': isOpened}">
        <div class="row" (click)="togglePanel()">
            <div class="col-10"> {{ projectName }} </div> 
            <div class="col-2"><i class="icon icon-chevron" [ngClass]="{'icon-active': isOpened}"></i></div>
        </div>
        <hr [ngClass]="{'hr-opened': isOpened}">
    </div>
    <div class="expansion-body" [ngClass]="{'active': isOpened}" [@contentExpansion]="isOpened ? 'expanded' : 'collapsed'">
        <ng-content></ng-content>
    </div>
</div>